import { AchievementCardProps, Card } from "@/components"
import { getValidClassNames } from "@/utils";
import { format } from "date-fns";

export const AchievementCard = ({ completedDate, goal, isComplete }: AchievementCardProps) => {
  return(
    <Card 
      additionalClassNames={getValidClassNames({
        "border-2 border-grey-400 shadow-none flex flex-col items-center py-6": true,
        "bg-green-400 border-green-400": Boolean(isComplete)
      })}
    >
      <img 
        alt="Achievements"
        className={getValidClassNames({
          "mb-4": true,
          "grayscale-1": Boolean(!isComplete)
        })}
        src="/images/achievement-icon.svg"  
      />
      <p className={getValidClassNames({
        "h6 mb-1 text-uppercase": true,
        "color-grey-600": !isComplete,
        "color-black": Boolean(isComplete)
      })}>
        {isComplete ? 'Complete' : 'Incomplete'}
      </p>
      {goal && (
        <>
          <p className="h5 text-center text-uppercase">{goal}</p>
          <hr className="bg-grey-500 w-8 my-3" />
        </>
      )}
      <p 
        className={getValidClassNames({
        'sr-only no-kanzi-speech': !completedDate
        })}
      >
        {completedDate ? format(new Date(String(completedDate)), 'dd/MM/yy') : '-'}
      </p>
    </Card>
  )
};